export const LICENSE_CALCULATOR_WIDGET_ENABLED_KEY =
  "license_calculator_widget_enabled";

export function readLicenseCalculatorWidgetEnabled() {
  const raw = localStorage.getItem(LICENSE_CALCULATOR_WIDGET_ENABLED_KEY);
  if (raw === "false") {
    return false;
  }
  if (raw === "true") {
    return true;
  }
  return true;
}

export function writeLicenseCalculatorWidgetEnabled(value) {
  localStorage.setItem(
    LICENSE_CALCULATOR_WIDGET_ENABLED_KEY,
    value ? "true" : "false",
  );
}
